module.exports = __webpack_public_path__ + "img/EMS_user_manual34.dd46ee3c.png";